import React, { useState, useEffect } from 'react';
import { Form, Col } from "react-bootstrap";
//imports core
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import GridItem from "components/Grid/GridItem.js";
import Table from "components/Table/Table.js";
import ModalUpdateSell from "components/ModalUpdateSell/ModalUpdateSell";
import ModalDeleteSell from "components/ModalDeleteSell/ModalDeleteSell";
import ModalDeleteSellAndOrder from "components/ModalDeleteSellAndOrder/ModalDeleteSellAndOrder";
import ModalChangeOperation from "components/ModalChangeOperation/ModalChangeOperation";
import ModalRemoveInHands from "components/ModalRemoveInHands/ModalRemoveInHands";
import ModalViewPayments from 'components/modalViewPayments/ModalViewPayments';
import CardFooter from 'components/Card/CardFooter';
import useAuth from "hooks/useAuth";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import { formatDate } from "services/formatDate.js";
import api from 'assets/services/api';
//imports material
import Icon from "@material-ui/core/Icon";
import ReceiptIcon from '@material-ui/icons/Receipt';
import Close from "@material-ui/icons/Close";
import Delete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Collapse, Typography, Box } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GetAppIcon from "@material-ui/icons/GetApp";
import ModalAddPaymentSell from 'components/ModalAddPaymentSell/ModalAddPaymentSell';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ModalDeliverySell from 'components/ModalDevliverySell/ModalDeliverySell';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    acctAll: {
        float: "right",
        marginTop: "-35px"
    },
    floatRight: {
        float: "right",
        marginRight: "56px",
        marginTop: "12px"
    },
    tp: {
        marginTop: "10px",
    },
    upload: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#000000",
        backgroundColor: "transparent",
        marginTop: "10px",
        border: "none",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

function TableSell({ sell, loadTotal, loadSell, toogleCancel, noFiscal }) {
    const { storageId, storageUserType } = useAuth();

    const classes = useStyles();
    const classes2 = useStyles2();
    const natures = {
        sell: "VENDA",
        bonification: "BONIFICAÇÃO",
        sample: "AMOSTRA",
        devolution: "DEVOLUÇÃO"
    };
    const [modal, setModal] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [modalShowOperation, setModalShowOperation] = useState(false);
    const [modalShowRemoveInHands, setModalShowRemoveInHands] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [modalShowDeleteSellAndOrder, setModalShowDeleteSellAndOrder] = useState(false);
    const [modalViewPayments, setModalViewPayments] = useState(false);
    const [modalAddPaymentSell, setModalAddPaymentSell] = useState(false)
    const [modalDeliverySell, setModalDeliverySell] = useState(false)
    const [index, setIndex] = useState(sell[0] ? sell[0] : { id: 1 });

    const [totalPrice2, setTotalPrice2] = useState(0);
    const [totalResult, setTotalResult] = useState(0);
    const [percentage, setPercentage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [payments, setPayments] = useState([]);
    useEffect(() => {
        totalPrice(sell);
    }, [sell]);
    useEffect(() => {
        if (expanded) {
            loadPayment();
        } else {
            setPayments([]);
        }
    }, [expanded]);

    const loadModal = async () => {
        setModal(true);
    };
    function callModalDelete(index) {
        if (!modalShowDelete) {
            loadModal();
        };
        setIndex(index);
        setModalShowDelete(true);
    };
    function callModalDeleteSellAndOrder(index) {
        if (!modalShowDeleteSellAndOrder) {
            loadModal();
        };
        setIndex(index);
        setModalShowDeleteSellAndOrder(true);
    };
    function callModalPassToOtherOperation(index) {
        if (!modalShowOperation) {
            loadModal();
        };
        setIndex(index);
        setModalShowOperation(true);
    };
    function callModalRemoveInHands(index) {
        if (!modalShowRemoveInHands) {
            loadModal();
        };
        setIndex(index);
        setModalShowRemoveInHands(true);
    };
    function callModalViewPayments(index) {
        console.log(index)
        if (!modalViewPayments) {
            loadModal();
        };
        setIndex(index);
        setModalViewPayments(true);
    }
    function callModalAddPaymentSell(index) {
        if (!modalAddPaymentSell) {
            loadModal();
        };
        setIndex(index);
        setModalAddPaymentSell(true);
    }
    function callModalAddDeliverytSell(index) {
        if (!modalDeliverySell) {
            loadModal();
        };
        setIndex(index);
        setModalDeliverySell(true);
    }
    async function openReceipt(sell) {
        //let link = "http://acesso.ctrcsistema.com.br:7000/CTRCSISTEMA/rastreamento2recibo.jsp?company=LIGA&cnpjcpf=01685851000188&p=123&db=LIGA&" + sell[0].receipt;
        let link2 = "https://api.dsaprospectos.com.br/image/" + sell[0].nf;
        if (sell[0].receipt) {
            //   window.open(link, "_blank")
        } else {
            window.open(link2, "_blank")
        }
    };
    async function loadPayment() {
        const response = await api.get(`/payment/sell/${sell[0].id_client}/${sell[0].nf}`)
        setPayments(response.data)
    };
    async function generateOrderStatement(nf, client) {
        setLoading(true);
        const response = await api.post('/sell/generate/statement/pdf', {
            id: storageId,
            data: [{ nf: nf }],
            type: "sell",
            userType: storageUserType
        }, {
            responseType: "blob", // Definido aqui
        }).then(async function (response) {
            let blob = new Blob([response.data], {
                responseType: "arraybuffer",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/pdf",
                },
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Venda_${client} - ${nf}.pdf`;
            link.click();
        }).catch(function (error) {
            console.log(error);
        });
        setLoading(false);
    };
    async function addPayments() {
        if (payments.length === 0) {
            console.log('if')
            const addPayment = await api.post('/payment/sell', {
                id_admin: sell[0].id_admin,
                nf: sell[0].nf,
                first: true
            });
            if (addPayment.status === 200) {
                loadPayment();
            };
        } else {
            callModalAddPaymentSell(payments[payments.length - 1])
        }
    };
    async function downloadPayment(fileName) {
        await api
            .get(`/payment/sell/${fileName}`, {
                responseType: "blob",
            })
            .then(function (response) {
                let blob = new Blob([response.data], {
                    responseType: "arraybuffer",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/pdf",
                    },
                });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = `Comprovante_${sell[0].social_reason}_${fileName}`
                link.click();
            })
            .catch(function (error) {
                alert(`Comprovante não encontrado`)
            });
    }
    function totalPrice(index) {
        let total = 0;
        let result = 0;
        for (let i = 0; i < index.length; i++) {
            total = parseFloat(total) + parseFloat(index[i].price_total);
            result = parseFloat(result) + parseFloat(index[i].result_operation);
        }
        setTotalPrice2(total)
        setTotalResult(result)
        setPercentage(result / total * 100);
    }

    function getNf() {
        let teste = [];
        for (let i = 0; i < sell.length; i++) {
            teste[i] = [];
            teste[i].push(sell[i].nf)
            teste[i].push(sell[i].fantasy_name)
            if (sell[i].id_product === 27 || sell[i].id_product === 49 || sell[i].id_product === 89 || sell[i].id_product === 113) {
                teste[i].push(sell[i].weight)
                teste[i].push((sell[i].weight / sell[i].box))
            } else {
                teste[i].push(sell[i].amount)
                teste[i].push((sell[i].amount / sell[i].box))
            }
            teste[i].push(sell[i].name)
            teste[i].push("R$" + sell[i].price)
            teste[i].push("R$" + sell[i].practice_price)
            teste[i].push("R$" + sell[i].discount)
            teste[i].push("R$" + sell[i].price_total)
            teste[i].push(formatDate(sell[i].date_of_sell))
            teste[i].push(sell[i].sellsman_name)
            teste[i].push(
                <CardIcon>
                    <Icon title={sell[i].validated ? "Validado" : "Não validado"}>{sell[i].validated ? "done" : "clear"}</Icon>
                </CardIcon>
            )
            teste[i].push(
                sell[i].date_of_delivery ? formatDate(sell[i].date_of_delivery) : "Não entregue"
            )
            teste[i].push(
                sell[i].deliverymanname ? sell[i].deliverymanname : "Não entregue"
            )
            teste[i].push("R$" + sell[i].result_operation)
            if (!toogleCancel) {
                if (storageUserType === "admin") {
                    teste[i].push(
                        <div className={classes2.tableActions}>
                            <Tooltip
                                id="tooltip-top-start"
                                title="Cancelar"
                                placement="top"
                                classes={{ tooltip: classes2.tooltip }}
                            >
                                <IconButton
                                    aria-label="Close"
                                    className={classes2.tableActionButton}
                                    onClick={() => callModalDelete(sell[i])}
                                >
                                    <Close
                                        className={
                                            classes2.tableActionButtonIcon + " " + classes2.close
                                        }
                                    />
                                </IconButton>
                            </Tooltip>
                            <Tooltip
                                id="tooltip-top-start"
                                title="Deletar venda e pedido"
                                placement="top"
                                classes={{ tooltip: classes2.tooltip }}
                            >
                                <IconButton
                                    aria-label="Close"
                                    className={classes2.tableActionButton}
                                    onClick={() => callModalDeleteSellAndOrder(sell[i])}
                                >
                                    <Delete
                                        className={
                                            classes2.tableActionButtonIcon + " " + classes2.close
                                        }
                                    />
                                </IconButton>
                            </Tooltip>
                        </div>
                    )
                }
            }

        }
        return teste;
    };

    function PaymentsTable() {
        let teste = [];
        for (let i = 0; i < payments.length; i++) {
            teste[i] = [];
            teste[i].push(payments[i].nf);
            teste[i].push(payments[i].payment_date);
            teste[i].push(payments[i].total_value);
            teste[i].push(payments[i].paid_value);
            teste[i].push(payments[i].remaining_value);
            teste[i].push(i > 0 ?
                <Form.Row>
                    <Form.Group as={Col} controlId="formGridBox">
                        <Form.Group as={Col} controlId="formGridBox">
                            <Tooltip id="tooltip-top" title={"Download SPC"} placement="top" classes={{ tooltip: classes2.tooltip }} >
                                <IconButton aria-label="Done" className={classes2.tableActionButton} onClick={() => downloadPayment(payments[i].file_name)} >
                                    <GetAppIcon
                                        className={classes2.tableActionButtonIconDownload + " " + classes2.edit4 + " " + classes.tp} />
                                </IconButton>
                            </Tooltip>
                        </Form.Group>
                    </Form.Group>
                </Form.Row> : <></>
            )

        };
        return teste;
    };

    function getHead() {
        let teste = [];

        if (toogleCancel) {
            teste = ["Nota Fiscal", "Fantasia", "Quantidade", "Quantidade em caixa", "Produto", "Preço", "Preço praticado", "Desconto", "Preço total", "Data da venda", "Vendadedor", "Status", "Data da entrega", "Entregador", "Resultado"]
        } else {
            teste = ["Nota Fiscal", "Fantasia", "Quantidade", "Quantidade em caixa", "Produto", "Preço", "Preço praticado", "Desconto", "Preço total", "Data da venda", "Vendedor", "Status", "Data da entrega", "Entregador", "Resultado", "Ações"]
        }

        return teste;
    };
    function getColor() {
        if (noFiscal) {
            if (sell[0].remaining_value === '0.00') {
                return "success"
            } else {
                return "danger"
            };
        } else {
            if (sell[0].remove_in_hands) {
                return "primary";
            } else if (sell[0].cancelled) {
                return "warning"
            } else if (sell[0].validated) {
                return "success"
            } else {
                return "danger"
            };
        };
    };
    return (
        <GridItem xs={12} sm={12} md={12}>
            {sell[0] !== undefined ? (
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader className={classes.zindex} color={getColor()}>
                            <Typography variant='h6' style={{ color: 'white' }}>
                                <Box>
                                    {sell[0].validated ?
                                        <Tooltip id="tooltip-top" title={"Recibo"} placement="top" classes={{ tooltip: classes2.tooltip }} >
                                            <IconButton aria-label="Done" className={classes2.tableActionButton} onClick={() => openReceipt(sell)} >
                                                <ReceiptIcon className={classes2.tableActionButtonIcon + " " + classes2.edit2} />
                                            </IconButton>
                                        </Tooltip>
                                        :
                                        <Tooltip id="tooltip-top" title={"Entrega"} placement="top" classes={{ tooltip: classes2.tooltip }} >
                                            <IconButton aria-label="Done" className={classes2.tableActionButton} onClick={() => callModalAddDeliverytSell(sell)} >
                                                <LocalShippingIcon className={classes2.tableActionButtonIcon + " " + classes2.edit2} />
                                            </IconButton>
                                        </Tooltip>}
                                    {natures[sell[0].nature]} - {sell[0].social_reason} - <Button variant="outlined"
                                        onClick={() => { generateOrderStatement(sell[0].nf, sell[0].social_reason) }}
                                        style={{
                                            borderColor: 'white',
                                            borderWidth: '3px',
                                            color: 'white',
                                            fontSize: '17px'
                                        }}>
                                        {sell[0].nf}
                                    </Button>
                                    {sell[0].nf > 1000000 ? <Button variant="outlined"
                                        onClick={() => callModalViewPayments(sell[0])}
                                        style={{
                                            borderColor: 'white',
                                            borderWidth: '3px',
                                            color: 'white',
                                            fontSize: '17px',
                                            marginRight: "56px",
                                            float: 'right'
                                        }}>Ver pagamentos</Button> : <div></div>}
                                </Box>
                            </Typography>
                            <Typography variant="body1" style={{ color: 'white', display: 'inline', fontSize: '1.5em' }}>
                                Total: R$ {totalPrice2.toFixed(2)} Resultado: R$ {totalResult.toFixed(2)} - {percentage.toFixed(2)}%
                                {sell[0].nf > 1000000 ? <span style={{ marginRight: "56px", float: 'right' }}> Devendo: {sell[0].remaining_value ? sell[0].remaining_value : "R$ 0,00"}</span> : <></>}
                            </Typography>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="danger"
                                index={index}
                                tableHead={getHead()}
                                tableData={getNf()}
                            />
                            {noFiscal ?
                                <>
                                    <div style={{ display: 'grid', flexDirection: 'row' }}>
                                        <Typography variant='subtitle1'>
                                            <Tooltip title="VER PAGAMENTOS">
                                                <IconButton onClick={() => setExpanded(!expanded)}>
                                                    {expanded ? <ExpandLessIcon sx={{ fontSize: 35 }} /> : <ExpandMoreIcon sx={{ fontSize: 35 }} />}
                                                </IconButton>
                                            </Tooltip>
                                            PAGAMENTOS
                                        </Typography>
                                    </div>
                                    <Collapse in={expanded}>
                                        <Box sx={{ width: '100%', display: 'grid', justifyItems: 'center' }}>
                                            <div style={{ p: 1, border: '1px solid #ccc', borderRadius: '4px', display: 'flex', width: '60%' }}>
                                                <Table
                                                    key={`pay_${sell[0].nf}`}
                                                    tableHeaderColor="primary"
                                                    tableHead={["Nota Fiscal", "Data", "Valor total", "Valor pago", "Valor restante", "Comprovante"]}
                                                    tableData={PaymentsTable()} />
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                                                <Button variant="contained" color="success" onClick={() => addPayments()}>NOVO PAGAMENTO</Button>
                                            </div>
                                        </Box>
                                    </Collapse>
                                </> : <></>
                            }
                        </CardBody>

                    </Card>
                    {modalShow && modal && (
                        <ModalUpdateSell key={String("upd_" + index.id)} props={index} loadSell={loadSell} show={modalShow} onHide={() => setModalShow(false)} />
                    )}
                    {modalShowDelete && modal && (
                        <ModalDeleteSell key={String("del_" + index.id)} props={index} loadSell={loadSell} loadTotal={loadTotal} show={modalShowDelete} onHide={() => setModalShowDelete(false)} />
                    )}
                    {modalShowDeleteSellAndOrder && modal && (
                        <ModalDeleteSellAndOrder key={String("delorder_" + index.id)} props={index} loadSell={loadSell} loadTotal={loadTotal} show={modalShowDeleteSellAndOrder} onHide={() => setModalShowDeleteSellAndOrder(false)} />
                    )}
                    {modalShowOperation && modal && (
                        <ModalChangeOperation key={String("chg_" + index.id)} props={index} loadSell={loadSell} loadTotal={loadTotal} show={modalShowOperation} onHide={() => setModalShowOperation(false)} />
                    )}
                    {modalShowRemoveInHands && modal && (
                        <ModalRemoveInHands key={String("rmv_" + index.id)} props={index} loadSell={loadSell} loadTotal={loadTotal} show={modalShowRemoveInHands} onHide={() => setModalShowRemoveInHands(false)} />
                    )}
                    {modalViewPayments && modal && (
                        <ModalViewPayments key={`pay_${index.id}`} props={index} loadSell={loadSell} show={modalViewPayments} onHide={() => setModalViewPayments(false)} />
                    )}
                    {modalAddPaymentSell && modal && (
                        <ModalAddPaymentSell key={`pay_${index.id}`} props={index} loadPayment={loadPayment} show={modalAddPaymentSell} onHide={() => setModalAddPaymentSell(false)} />
                    )}
                    {modalDeliverySell && modal && (
                        <ModalDeliverySell key={`delivery_${index.id}`} props={index} loadSell={loadSell} show={modalDeliverySell} onHide={() => setModalDeliverySell(false)} />
                    )}
                </GridItem >
            ) : <div></div>
            }
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
                onClick={() => { }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </GridItem >
    );
}

export default TableSell;